import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { Subscription } from "rxjs";
import UserNotification from "../../../models/notificiations/notification";
import { AlertsDataService } from "../../../providers/alerts-data-service/alerts-data-service";
import { UserNotificationsService } from "../../../providers/users-service/user-notifications.service";
import { NavigationService } from "../../navigation.service";

@Component({
  selector: "alerts-popover",
  templateUrl: "alerts-popover.html",
})
export class AlertsPopoverPage {
  version: boolean = false;
  alertsCount: number = 0;
  profileName: string;
  dataUrl: string;
  alerts: any[] = [];
  notifications: UserNotification[] = [];
  _newAlert: any;
  private notificationSub: Subscription;

  constructor(
    public navParams: NavParams,
    public navSvc: NavigationService,
    public alertsData: AlertsDataService,
    public userNotificationsService: UserNotificationsService,
    public viewCtrl: ViewController
  ) {
    this.alertsCount = this.navParams.get("alertsCount");
    this.version = this.navParams.get("version");
  }

  getAlerts() {
    // commented in users branch
    // this.alertsData.getNewAlerts().subscribe(data => {
    //   this.alerts = data;
    // });
    // this.alertsData.getNewAlertsCount().subscribe(data => {
    //   this.alertsCount = Number(data);
    //   this.alertsData.setAlertsCount(this.alertsCount);
    // });
  }

  ionViewWillEnter() {
    if (!this.version) {
      this.getAlerts();
      this._newAlert = this.alertsData.newAlert.subscribe((data) => {
        this.getAlerts();
      });
    } else {
      this.notificationSub = this.userNotificationsService
        .getNotifications()
        .subscribe((x) => {
          this.notifications = x;
        });
    }
  }

  ionViewWillLeave() {
    if (this.alerts.length > 0) {
      // commented in users branch
      // const ids = this.alerts.filter(alert => alert.status === 'New').map(alert => alert.eventRecipientId);
      // if (ids.length) {
      //   this.alertsData.viewAlerts(ids).subscribe(data => {
      //     this.getAlerts();
      //   });
      // }
      this._newAlert.unsubscribe();
    }
  }

  goToAlertsDashboard() {
    this.viewCtrl.dismiss();
    this.navSvc.goToInternalPage("AlertDashboardPage", {});
  }

  dismiss(dismissAlert) {
    // commented in users branch
    // this.alertsData.dismissAlert(dismissAlert.eventRecipientId).subscribe(data => {
    //   this.alertsData._dismissedAlert.next(dismissAlert.eventRecipientId);
    //   this.getAlerts();
    // });
  }

  formatMessage(message: string) {
    const listIndex = message.indexOf("<ul>");
    if (listIndex > -1) {
      const listItems =
        " &#9679 " +
        message
          .substring(listIndex)
          .replace(/<ul><li>|<\/li><\/ul>/gi, "")
          .split("</li><li>")
          .map((item) => item.charAt(0).toUpperCase() + item.substr(1))
          .join(", ");
      message = message.substring(0, listIndex) + listItems;
    }
    const patt = /<a href="(.*?)">/g;
    const match = patt.exec(message);
    let limit = 100;
    if (match) {
      limit += match[0].length;
    }
    if (message.length > limit) {
      message = message.substring(0, limit - 3) + "...";
    }
    return message;
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/alerts-popover/alerts-popover.ts